"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _Search = _interopRequireDefault(require("elevate-ui-icons/Search"));

var _ToolboxItem = _interopRequireDefault(require("./ToolboxItem"));

var ComponentList = function ComponentList(_ref) {
  var activeComponent = _ref.activeComponent,
      classes = _ref.classes,
      components = _ref.components,
      filterComponents = _ref.filterComponents,
      filterInput = _ref.filterInput,
      handleComponentClick = _ref.handleComponentClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: classes.inputWrapper
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: classes.input,
    type: "text",
    value: filterInput,
    onChange: filterComponents,
    placeholder: "Filter components...",
    autoFocus: true
  }), /*#__PURE__*/_react["default"].createElement(_Search["default"], {
    className: classes.inputIcon,
    size: 32
  })), components.map(function (component) {
    if (component.toolbarDisabled) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement(_ToolboxItem["default"], {
      active: activeComponent && activeComponent.type === component.type ? true : false,
      key: component.type,
      className: classes.toolboxItem,
      label: component.label || component.type,
      handleComponentClick: handleComponentClick,
      type: component.type
    });
  }));
};

var styles = function styles(theme) {
  return {
    root: (0, _defineProperty2["default"])({
      position: "relative",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "100%",
      height: "100%",
      padding: "20px",
      overflowY: "scroll",
      overflowX: "visible",
      borderRight: "1px solid ".concat(theme.colors["gray200"])
    }, theme.breakpoints(900), {
      flex: "0 0 300px"
    }),
    toolboxItem: {
      marginBottom: 10
    },
    inputWrapper: {
      flex: "0 0 auto",
      display: "flex",
      position: "relative",
      flexFlow: "row nowrap",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      height: 50,
      marginBottom: 20,
      overflowX: "visible"
    },
    input: {
      display: "block",
      width: "100%",
      height: "40px",
      color: theme.typography.bodyColor,
      fontFamily: "inherit",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px",
      backgroundColor: "#fff",
      border: "1px solid ".concat(theme.colors.gray200),
      borderRadius: theme.globalBorderRadius,
      padding: "8px 46px 8px 12px",
      boxShadow: "none",
      // Reset default inputs for mozilla
      "-webkit-appearance": "none",
      // Reset default browser styles
      "-moz-appearance": "none",
      // Reset default browser styles
      "&:focus": {
        outline: "none",
        // Disable default focus glow
        boxShadow: theme.globalBoxShadow // Add back focus style

      },
      "&:disabled": {
        cursor: "not-allowed"
      }
    },
    inputIcon: {
      position: "absolute",
      color: theme.colors.gray300,
      right: 10
    }
  };
};

var _default = (0, _withStyles["default"])(styles)(ComponentList);

exports["default"] = _default;